import {
  useEffect,
  useState } from 'react';
import {
    Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Switch
} from '@mui/material';
import { aggiornaStanza, getAllStanze } from '../APIs/RoomsAPI';
import { useTheme } from "@mui/material/styles";
import Autocomplete from '../components/SearchableAutocomplete';
import { useTranslation } from 'react-i18next';
import { getTenantTranslation } from '../utils/getTenantTranslation';
import { useSnackbar } from '../contexts/SnackBarContext';

const ModalEditSala = ({ open, onClose, onSuccess }) => {
    const [nome, setNome] = useState('');
    const [errSala, setErrSala] = useState(false)
    const { t } = useTranslation()
    const theme = useTheme();
    const { showSnackbar } = useSnackbar();
    const tenantType = localStorage.getItem('tenantType');

    const [stanze, setStanze] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null)
    const [is_active, setIs_active] = useState(true)

    useEffect(() => {
        if (open) {
            const token = localStorage.getItem('accessToken');
            const tenant = localStorage.getItem('tenantId');
            getAllStanze(token, tenant).then(data => setStanze(data)).catch(err => console.error(err));
        }
    }, [open]);

    const handleSubmit = async () => {
        const token = localStorage.getItem('accessToken');
        const tenant = localStorage.getItem('tenantId');
        if (!selectedRoom) return;
        const trimmedName = nome.trim();
        if (!trimmedName) return;

        setErrSala(false)

        try {
            const payload = {};
            if (trimmedName !== selectedRoom.name) payload.name = trimmedName;
            if (is_active !== selectedRoom.active) payload.active = is_active;
            if (Object.keys(payload).length === 0) return;

            await aggiornaStanza(selectedRoom.id, payload, token, tenant);
            if (onSuccess) onSuccess();
            handleClose(); // Chiudi il modale dopo la creazione
        } catch (err) {
            handleAlert("modals_alert.error_createRoom" + err.message);
            setErrSala(true)
        }
    };

    const handleClose = () => {
        setNome('');
        setIs_active(true);
        setSelectedRoom(null);
        setErrSala(false)
        onClose();
    };

    function handleAlert(msg, type) {
        showSnackbar(msg, type)
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>{getTenantTranslation(t, tenantType, 'editRoom')}</DialogTitle>
            <DialogContent>
                <Autocomplete
                    options={stanze}
                    getOptionLabel={(option) => option.name}
                    id="selectTable"
                    value={selectedRoom}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    onChange={(e, newValue) => {
                        setSelectedRoom(newValue)
                        setNome(newValue?.name || '');
                        setIs_active(newValue?.active ?? true);
                        if (document.activeElement)
                            document.activeElement.blur();
                    }}
                    renderInput={(params) => (<TextField {...params} label={getTenantTranslation(t, tenantType, "booking.room")} variant="outlined" sx={{
                        ...{
                            "& .MuiInputLabel-root": {
                                top: -8,
                                color: theme.checkout.orange_outline_button.color,
                            },
                            "& .MuiInputBase-root": {
                                height: "36px",
                                minHeight: "unset", // rimuove i limiti minimi di MUI
                            },
                        },
                        ...theme.checkout.orange_outline_button
                    }} />)}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label={getTenantTranslation(t, tenantType, "new_room_name")}
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                />
                <FormControlLabel label={getTenantTranslation(t, tenantType, "active")} control={<Switch checked={is_active} onChange={() => { setIs_active(!is_active) }} />} />
                <Typography color="red">{errSala ? "Nome Sala Già Esistente" : ""}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{getTenantTranslation(t, tenantType, 'cancel')}</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!selectedRoom || !nome.trim() || (nome.trim() === selectedRoom.name && is_active === selectedRoom.active)}
                >
                    {getTenantTranslation(t, tenantType, 'save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalEditSala;
